import type SearchOrigin from '@alltrails/amplitude/enums/SearchOrigin';
import type SearchResultSelectionMethod from '@alltrails/amplitude/enums/SearchResultSelectionMethod';
import logGuideClicked from '@alltrails/amplitude/events/logGuideClicked';
import logGuideIndexClicked from '@alltrails/amplitude/events/logGuideIndexClicked';
import logSearchResultClicked from '@alltrails/amplitude/events/logSearchResultClicked';
import type { AlgoliaSearchResult } from '@alltrails/types/AlgoliaResults';
import { getSearchItemType, getSearchSelectionType } from './algoliaAnalyticsHelpers';
import { addRecentAlgoliaHit } from './recentAlgoliaSearches';

type RecordAlgoliaResultSelectionArgs = {
  clickPosition?: number;
  /** The search result clicked event is only logged when a location is given */
  location?: SearchOrigin;
  query?: string;
  recommendationKind?: string;
  result: AlgoliaSearchResult;
  selectionMethod?: SearchResultSelectionMethod;
};

/**
 * Saves a selected Algolia result as a recent search and logs its selection events.
 */
const recordAlgoliaResultSelection = ({
  clickPosition,
  location,
  query,
  recommendationKind,
  result,
  selectionMethod
}: RecordAlgoliaResultSelectionArgs) => {
  addRecentAlgoliaHit({ objectID: result.objectID, type: result.type });
  if (location) {
    logSearchResultClicked({
      click_position: clickPosition,
      content_id: result.id,
      item_type: getSearchItemType(result.type),
      location,
      poi_type_raw: result.type === 'poi' ? result.subtype : undefined,
      query_length: query?.length,
      query_text: query,
      recommendation_type_raw: result.searchType === 'recommendation' ? recommendationKind : undefined,
      selection_method: selectionMethod,
      selection_type: getSearchSelectionType(result.searchType)
    });
  }
  if (result.type === 'guide') {
    logGuideClicked({
      guide_id: String(result.ID),
      source_type: 'search',
      vertical_index: clickPosition
    });
  }
  if (result.type === 'page' && result.subtype === 'guides') {
    logGuideIndexClicked({
      guide_index_location: 'search'
    });
  }
};

export default recordAlgoliaResultSelection;
